import {
  Box,
  FormControl,
  Heading,
  Input,
  InputGroup,
  Stack,
  Text,
} from "@chakra-ui/react"
import * as React from "react"
import { getApiUrl } from "../../utils/loginInfo"
import { AuthButton } from "./AuthHeader"

export function ForgotPassword() {
  const [email, setEmail] = React.useState("")

  const submitForm = () => {
    if (email) {
      fetch(`${getApiUrl()}/user/forgot_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-M-P": "3",
        },
        body: JSON.stringify({ email: email }),
      }).then(res => console.log(res))
    }
  }
  return (
    <>
      <Heading
        textTransform="uppercase"
        fontSize="30px"
        lineHeight="24px"
        color="black"
        fontWeight="600"
        textAlign="center"
        mb="32px"
      >
        Forgot Your Password?
      </Heading>

      <Box py="8" px={{ base: "4", md: "10" }}>
        <form
          onSubmit={event => {
            event.preventDefault()
            submitForm()
          }}
        >
          <Stack spacing={4}>
            <Text>Enter your email address to reset your password.</Text>
            <FormControl>
              <InputGroup>
                <Input
                  type="email"
                  placeholder="email address"
                  value={email}
                  onChange={event => setEmail(event.target.value)}
                />
              </InputGroup>
            </FormControl>
            <AuthButton label="Reset My Password" />
          </Stack>
        </form>
      </Box>
    </>
  )
}
